(function($) {
  'use strict';

  const gallery = {
    dotLimit: 6,

    dom: function() {
      gallery.$galleries = $('.gallery');
    },

    addFancyboxRel: function($gallery) {
      let $galleryItem = $gallery.find('.gallery__item').first();
      let gallery = $galleryItem.find('.gallery__link').attr('data-fancybox');
      $gallery.find('.gallery__item.hidden .gallery__link').attr('data-fancybox', gallery);
      let $modalLinks = $('[data-fancybox]');
      $modalLinks.unbind('click.fb-start');
      $('[data-fancybox]').fancybox(jonahConfig.fancyboxSettings);
    },

    showAll: function($gallery) {
      $gallery.find('[data-load-gallery]').click(function() {
        $(this).hide();
        gallery.addFancyboxRel($gallery);
        $gallery.find('.gallery__item.hidden').show().removeClass('hidden');
      });
    },

    setDots: function(slick, currentSlide) {
      if (slick.$dots && slick.slideCount > (gallery.dotLimit + 1)) {
        let halfDotLimit = gallery.dotLimit / 2;
        let $dots = slick.$slider.find('.slick-dots li');
        let limitBottom = currentSlide - halfDotLimit >= 0 ? currentSlide - halfDotLimit : 0;
        let limitTop = currentSlide + halfDotLimit;
        let stopMore = slick.slideCount - halfDotLimit;
        let stopMax = slick.slideCount - (gallery.dotLimit + 1);

        $dots.each(function(index) {
          $(this).removeClass('hide');
          if (currentSlide > halfDotLimit) {
            if (currentSlide >= stopMore) {
              if (index < stopMax) {
                $(this).addClass('hide');
              }
            }
            else if (index < limitBottom || index > limitTop) {
              $(this).addClass('hide');
            }
          }
          else {
            if (index > gallery.dotLimit) {
              $(this).addClass('hide');
            }
          }
        });
      }
    },

    carousel: function($gallery) {
      const $carousel = $gallery.find('.gallery__items');

      $carousel.on('init', function(event, slick) {
        gallery.setDots(slick, slick.currentSlide);
      });

      $carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        gallery.setDots(slick, nextSlide);
      });

      $carousel.slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        prevArrow: '<button type="button" class="slick-arrow slick-prev btn btn-primary">' + jcms.settings.navPrev + '</button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next btn btn-primary">' + jcms.settings.navNext + '</button>',
        responsive: [
          {
            breakpoint: 808,
            settings: {
              dots: true,
              arrows: false,
            }
          }
        ]
      });
    },

    slider: function($gallery) {
      const $slider = $gallery.find('.gallery__items');

      $slider.on('init', function(event, slick) {
        gallery.setDots(slick, slick.currentSlide);
      });

      $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        let $slide = $(slick.$slides[nextSlide]);
        let $bg = $slide.find('.gallery__item-bg');
        let $image = $slide.find('.gallery__image');

        if (!$bg.hasClass('loaded') && typeof $bg.attr('data-src') != 'undefined') {
          $bg.css('background-image', 'url(' + $bg.attr('data-src') + ')').addClass('loaded');
        }

        if (!$image.hasClass('loaded') || $image.attr('src') !== $image.attr('data-src')) {
          $image.attr('src', $image.attr('data-src')).addClass('loaded');
        }

        gallery.setDots(slick, nextSlide);
      });

      $slider.slick({
        arrows: true,
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        prevArrow: '<button type="button" class="slick-arrow slick-prev btn btn-primary">' + jcms.settings.navPrev + '</button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next btn btn-primary">' + jcms.settings.navNext + '</button>',
        responsive: [
          {
            breakpoint: 808,
            settings: {
              arrows: false,
              dots: true
            }
          },
        ]
      });
    },

    masonry: function($gallery) {
      if ($gallery.length) {
        let galIsotope = $gallery.find('.gallery__items').isotope({
          itemSelector: '.gallery__item:not(.hidden)',
          layoutMode: 'masonry'
        });

        let $extraItems = $gallery.find('.gallery__item.hidden');

        if ($extraItems.length) {
          $gallery.find('[data-load-gallery]').click(function() {
            $(this).hide();
            gallery.addFancyboxRel($gallery);
            $extraItems.show().removeClass('hidden');
            galIsotope.isotope( 'reloadItems' ).isotope();
          });
        }
      }
    },

    galleries: function() {
      gallery.$galleries.each(function() {
        let $gallery = $(this);

        if ($gallery.hasClass('layout-3')) {
          gallery.carousel($gallery);
        }
        else if ($gallery.hasClass('layout-4')) {
          gallery.slider($gallery);
        }
        else if ($gallery.hasClass('layout-5')) {
          gallery.masonry($gallery);
        }

        if (!$gallery.hasClass('layout-5')) {
          gallery.showAll($gallery);
        }
      });
    },

    ready: function() {
      this.dom();
      this.galleries();
    }
  };

  $(function() { gallery.ready(); });

})(jQuery);
